import React from 'react';
import TableBoolean from "../../components/Table/TableBoolean/TableBoolean";
import moment from 'moment';

export const columns = [
    {
        dataField: 'name',
        text: 'Name',
        sort: true,
        headerStyle: { borderColor: '#a81933' }
    },
    {
        dataField: 'description',
        text: 'Description',
        sort: true,
        headerStyle: { borderColor: '#a81933' }
    },
    {
        dataField: 'statusName',
        text: 'Status',
        sort: true,
        headerStyle: { borderColor: '#a81933', width: '120px' },
        formatter: (_cell, row) => <TableBoolean value={row.statusId === 1} text={row.statusName} />,

    },
    {
        dataField: 'franchiseCount',
        text: 'Instances',
        sort: true,
        headerStyle: { borderColor: '#a81933', width: '120px' }
    },
    {
        dataField: 'createdByName',
        text: 'Created By',
        sort: true,
        headerStyle: { borderColor: '#a81933' }
    },
    {
        dataField: 'createdAt',
        text: 'Created On',
        sort: true,
        headerStyle: { borderColor: '#a81933', width: '150px' },
        formatter: (_cell, row) => {
            return moment(row.createdAt).format('MM/DD/YYYY')
        }
    }
];

export const sorting = [{
    dataField: 'name',
    order: 'asc'
}];